<template>
  <div class="withdraw-card" v-if="showModal">
    <div class="overlay-modal">
      <div class="modal-content">
        <div class="modal-header">
          <div class="type-calendar text-center">
              <h2 class="text-center">利用解除</h2>
          </div>
        </div>
        <div class="modal-body">
          <div class="remove-account">

              <div class="container-370" v-if="currentStep === 1">
                  <div class="text-warning">
                    「ポケットミーティング」をご利用いただきましてありがとうございました。<br>
                    本ページでは、「利用解除」にあたっての注意事項をご説明します。<br><br>

                    ・ポケットミーティング上の登録ユーザを破棄します（ただし、ポケットファーマシー側のユーザ情報は破棄しません）。<br><br>

                    以上の内容をご確認の上、「利用解除する」ボタンを押下してください。
                  </div>
                  <div class="buttons-flex">
                      <router-link :to="{name: 'home'}" class="button default flex-1 mt-40">操作を取消す</router-link>
                      &nbsp;
                      <a @click="changeStep(currentStep + 1)" class="button danger flex-1 mt-40">利用解除する</a>
                  </div>
              </div>

              <div class="container-370" v-if="currentStep === 2">
                  <div class="main-title text-center"><h3>利用解除の手続きが完了しました。</h3></div>

                  <div class="text-guide mt-10">
                      ポケットファーマシーのアカウントも削除される場合は、以下からお手続きにお進みください。
                  </div>

                  <div class="buttons-flex mt-40 mb-15">
                      <a :href="ppUnregisterUrl" class="button danger flex-1">ポケットファーマシーを利用解除する</a>
                  </div>

                  <div class="buttons-flex">
                      <a @click="finalize()" class="button default flex-1">トップに戻る</a>
                  </div>
              </div>
          </div>
        </div>
        <div class="modal-footer">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountApi from '@/api/account'
import MasterDataApi from '@/api/master'
import {apiErrorDialog} from '@/helpers'

export default {
  data () {
    return {
      currentStep: 1,
      ppUnregisterUrl: '',
      showModal: true,
    }
  },
  methods: {
    changeStep (step) {
      this.currentStep = step
      this.submit()
    },
    async submit () {
      const loading = this.$loading.show()
      await AccountApi.withdraw()
        .catch((error) => {
          loading.hide()
          apiErrorDialog(this, error)
        })
      loading.hide()
    },
    async finalize () {
      this.$auth.logout()
    }
  },
  async created () {
    const masterDataApi = await MasterDataApi.get()
      .catch((error) => {
        apiErrorDialog(this, error)
      })
    const masterData = masterDataApi.data.data
    this.ppUnregisterUrl = masterData.unregister_url
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/account/Delete.vue